import { BaseApi } from '@Features/Base/BaseApi/BaseApi'
import classroomApi from '@Features/Classroom/ClassroomSlice/ClassroomSlice'

const CourseApi = BaseApi.enhanceEndpoints({ addTagTypes: ['Section', 'GO_TO_COURSE'] }).injectEndpoints({
	overrideExisting: true,
	endpoints: builder => ({
		goToCourseById: builder.query<ApiResponse<CourseOverviewPayload>, number>({
			query: (id: number) => ({
				url: `/course/${id}`,
			}),
			providesTags: (result, error, args) => {
				return [{ type: 'GO_TO_COURSE', id: args }]
			},
			async onQueryStarted(arg, api) {
				try {
					await api.queryFulfilled
				} catch (error) {
					// course fetch failed (expired/removed enrollment, deactivated course…)
					// — refetch the classroom so its tree reflects the server state
					api.dispatch(classroomApi.util.invalidateTags(['CLASSROOM']))
				}
			},
		}),
		getTabById: builder.query<ApiResponse<Tab>, number>({
			query: (id: number) => ({ url: `/classroom/tab/${id}` }),
			keepUnusedDataFor: 0,
		}),
		getSectionById: builder.query<ApiResponse<TabSection>, number>({
			query: (id: number) => ({ url: `/classroom/section/${id}` }),
			providesTags: (result, error, arg) => [{ type: 'Section', id: arg }],
			keepUnusedDataFor: 0,
		}),
	}),
})

export default CourseApi

export const {
	useGoToCourseByIdQuery,
	useLazyGoToCourseByIdQuery,
	useGetTabByIdQuery,
	useLazyGetTabByIdQuery,
	useLazyGetSectionByIdQuery,
	useGetSectionByIdQuery,
} = CourseApi
